var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 0.333496C7.79992 0.333496 0.333252 7.80016 0.333252 17.0002C0.333252 26.2002 7.79992 33.6668 16.9999 33.6668C26.1999 33.6668 33.6666 26.2002 33.6666 17.0002C33.6666 7.80016 26.1999 0.333496 16.9999 0.333496ZM24.7332 11.6668C24.4832 14.3002 23.3999 20.7002 22.8499 23.6502C22.6166 24.9002 22.1499 25.3168 21.7166 25.3668C20.7499 25.4502 20.0166 24.7335 19.0833 24.1168C17.6166 23.1502 16.7833 22.5502 15.3666 21.6168C13.7166 20.5335 14.7833 19.9335 15.7333 18.9668C15.9833 18.7168 20.2499 14.8335 20.3333 14.4835C20.3448 14.4305 20.3433 14.3754 20.3288 14.3232C20.3142 14.2709 20.2872 14.2229 20.2499 14.1835C20.1499 14.1002 20.0166 14.1335 19.8999 14.1502C19.7499 14.1835 17.4166 15.7335 12.8666 18.8002C12.1999 19.2502 11.5999 19.4835 11.0666 19.4668C10.4666 19.4502 9.33325 19.1335 8.48325 18.8502C7.43325 18.5168 6.61659 18.3335 6.68325 17.7502C6.71659 17.4502 7.13325 17.1502 7.91659 16.8335C12.7833 14.7168 16.0166 13.3168 17.6333 12.6502C22.2666 10.7168 23.2166 10.3835 23.8499 10.3835C23.9833 10.3835 24.2999 10.4168 24.4999 10.5835C24.6666 10.7168 24.7166 10.9002 24.7332 11.0335C24.7166 11.1335 24.7499 11.4335 24.7332 11.6668Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTgIcon);
export default __webpack_public_path__ + "static/media/tg_icon.ff705446cfae8c96d0cc3c10b7c92934.svg";
export { ForwardRef as ReactComponent };